export {
  genericSelectors as timeEntriesGenericSelectors,
  selectors as timeEntriesSelectors,
  actions as timeEntriesActions,
  reducer as timeEntriesReducer,
  sortComparer
} from './timeEntriesSlice'
export type { TimeEntriesState } from './timeEntriesSlice'
